import { Util,Request } from "@xt/xtbase";
const { getOrigin } = Util;
const { XtAxios } = Request;

const URL = getOrigin("www") + "/xt-report-stream/";

//30天交易量
export function getUserTradeValue(config) {
  return XtAxios.get(URL + `user-trade-value`, config);
}

